import { Badge, Button, Modal } from "@indigo-components";
import React from "react";

interface NotificationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  title: string;
  subtitle: React.ReactNode;
  errors?: string[];
  /**
   * Technical lines (function name, status, request id, raw message) shown
   * behind a "Dev only" badge. Callers are expected to populate this in the
   * dev environment only — see error-handling/userFacingError.ts.
   */
  devDetails?: string[];
}

const NotificationModal: React.FC<NotificationModalProps> = ({
  isOpen,
  onConfirm,
  title,
  subtitle,
  errors,
  devDetails,
}) => {
  return (
    <Modal
      title={null}
      open={isOpen}
      onCancel={onConfirm}
      footer={null}
      centered
      closable={false}
      width={357}
      className="flex flex-col justify-between"
    >
      <div className="p-1">
        {title && (
          <h2
            style={{
              color: "var(--indigo-text-primary)",
              fontSize: "16px",
              fontFamily: "var(--indigo-font-body)",
              margin: 0,
              marginBottom: "8px",
              fontWeight: 600,
            }}
          >
            {title}
          </h2>
        )}

        <p
          style={{
            color: "var(--indigo-text-secondary)",
            fontSize: "14px",
            fontFamily: "var(--indigo-font-body)",
            lineHeight: "18px",
            marginBottom: "16px",
            marginTop: "8px",
          }}
        >
          {subtitle}
        </p>
        {errors &&
          errors.map((error, index) => (
            <p
              key={index}
              style={{
                color: "var(--indigo-text-secondary)",
                fontSize: "14px",
                fontFamily: "var(--indigo-font-body)",
                lineHeight: "18px",
                marginBottom: "16px",
                marginTop: "8px",
              }}
            >
              {error}
            </p>
          ))}
        {devDetails && devDetails.length > 0 && (
          <div
            style={{
              border: "1px dashed var(--indigo-border-default)",
              borderRadius: "6px",
              padding: "8px",
              marginTop: "12px",
            }}
          >
            <Badge label="Dev only" size="sm" variant="amber" />
            {devDetails.map((detail) => (
              <p
                key={detail}
                style={{
                  color: "var(--indigo-text-secondary)",
                  fontSize: "11px",
                  fontFamily: "monospace",
                  lineHeight: "15px",
                  margin: "6px 0 0",
                  wordBreak: "break-word",
                }}
              >
                {detail}
              </p>
            ))}
          </div>
        )}
      </div>
      <div className="flex justify-end gap-[10px] p-1">
        <Button variant="primary" size="md" onClick={onConfirm}>
          Okay
        </Button>
      </div>
    </Modal>
  );
};

export default NotificationModal;
